import React, { useState } from 'react';
import { Button } from 'antd';
import { BellOutlined, CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { auth } from '../../lib/firebaseAuth';
import { trackConversion } from '../../lib/conversionEvents';
import type { MatchRequestKind } from '../../shared/utils/match-request';

type Status = 'idle' | 'sending' | 'sent' | 'error';

/**
 * LG-64: rakipten fotoğraf/not isteği. Gönderildi durumu yalnız sunucu onayından sonra gösterilir;
 * aynı istek ikinci kez bildirim üretmez (sunucu `alreadyRequested` döner). C4 (3 Kasım): eksik
 * olanlar (fotoğraf ve/veya not) tek düğmeyle, sırayla istenir; düğme bağlantı değil, belirgin buton.
 */
export default function MatchRequestButton({
  matchId,
  kinds,
}: {
  matchId: string;
  kinds: MatchRequestKind[];
}) {
  const { t } = useTranslation('leagues');
  const [status, setStatus] = useState<Status>('idle');

  const send = async () => {
    const user = auth.currentUser;
    if (!user) return;
    setStatus('sending');
    try {
      const token = await user.getIdToken();
      // eslint-disable-next-line no-restricted-syntax -- en çok iki istek, bilerek sırayla
      for (const kind of kinds) {
        const params = new URLSearchParams({ matchId, kind });
        // eslint-disable-next-line no-await-in-loop -- sırayla (tek bildirim kuyruğu)
        const response = await fetch(`/api/league-match-request?${params}`, {
          method: 'POST',
          cache: 'no-store',
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) throw new Error('MATCH_REQUEST');
      }
      trackConversion('feed_match_request');
      setStatus('sent');
    } catch {
      setStatus('error');
    }
  };

  if (status === 'sent') {
    return (
      <p className="match-request__sent" role="status">
        <CheckOutlined aria-hidden="true" /> {t('detail.feed.requestSent')}
      </p>
    );
  }
  return (
    <>
      <Button
        className="match-request"
        icon={<BellOutlined aria-hidden="true" />}
        loading={status === 'sending'}
        onClick={send}
      >
        {t(
          kinds.length > 1
            ? 'detail.feed.requestBoth'
            : kinds[0] === 'foto'
            ? 'detail.feed.requestPhoto'
            : 'detail.feed.requestNote',
        )}
      </Button>
      {status === 'error' && (
        <p className="match-request__error" role="alert">
          {t('detail.feed.requestError')}
        </p>
      )}
    </>
  );
}
